<template>
  <div class="details-video">
    <div class="details-video__inner">
      <youtube
        ref="video"
        :video-id="src"
        :player-vars="{ playsinline: 1 }"
      />
      <div
        v-if="paused"
        :style="{ backgroundImage: `url(${ videoPlaceholder })` }"
        class="details-video__cover"
      />
      <div v-if="paused" class="details-video__btn">
        <button-component @click="handleClick">Play</button-component>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonComponent from '@/components/Button'

export default {
  components: {
    ButtonComponent
  },
  props: {
    src: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      paused: true
    }
  },
  computed: {
    videoPlaceholder () {
      return `https://img.youtube.com/vi/${ this.src }/0.jpg`
    }
  },
  methods: {
    handleClick () {
      const { video } = this.$refs

      video.player.playVideo()
      this.paused = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .details-video {
    position: relative;

    &__inner {
      position: relative;
      overflow: hidden;
      width: 100%;
      padding-top: 56.25%;

      /deep/ iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }

    &__cover {
      @include cover-background();
      background-color: $accent-color;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }

    &__media {
      min-width: 100%;
      width: 100%;
      display: block;
    }

    &__btn  {
      position: absolute;
      z-index: 1;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
</style>



// WEBPACK FOOTER //
// src/containers/Details/DetailsVideo.vue